export function* convertTouchListToGen(touch_list) {
  const len = touch_list.length;
  for (let i = 0; i < len; i++) {
    const touch = touch_list.item(i);
    if (touch == null) {
      return;
    }
    yield touch;
  }
}
